import React from 'react';

const Banner = () => {
  return (
    <div className="relative w-full">
      <img
        src="/banner.png"
        alt="Banner"
        className="w-full h-auto block"
      />
      <div className="absolute inset-0 bg-black/20"></div>
    </div>
  );
};

export default Banner;